module.exports = __webpack_public_path__ + "./docs/img/big-icon-constants.c137746725945434d7175c236b347cd6.svg";